export default [
  {
    header: 'Giriş Sayfası',
  },
  {
    title: 'Güncel Durum',
    route: 'home',
    icon: 'BarChart2Icon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Anasayfa Ayarları',
    route: 'WelcomePage',
    icon: 'BookmarkIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Slide Görseller',
    route: 'Carousel',
    icon: 'ImageIcon',
    resource: 'CAROUSEL_LIST',
    action: 'read',
  },
  {
    title: 'Duyurular',
    route: 'Notifications',
    icon: 'BellIcon',
    resource: 'NOTIFICATION_LIST',
    action: 'read',
  },
  {
    header: 'Menü Yönetimi',
  },
  {
    title: 'Ürünler',
    route: null,
    icon: 'CoffeeIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ProductAdd',
        resource: 'PRODUCT_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Products',
        resource: 'PRODUCT_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kategoriler',
    route: null,
    icon: 'FolderIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'CategoryAdd',
        resource: 'CATEGORY_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Categories',
        resource: 'CATEGORY_LIST',
        action: 'read',
      },
    ],
  },
  {
    header: 'Restoran Yönetimi',
  },
  {
    title: 'Şube Yönetimi',
    route: 'Branches',
    icon: 'SettingsIcon',
    resource: 'BRANCHES_LIST',
    action: 'read',
  },
  {
    title: 'Bağlantı Yönetimi',
    route: 'QrCodes',
    icon: 'GridIcon',
    resource: 'QR_CODE_LIST',
    action: 'read',
  },
  {
    title: 'Geri Bildirimler',
    route: 'Feedbacks',
    icon: 'MessageSquareIcon',
    resource: 'FEEDBACKS_LIST',
    action: 'read',
  },
  {
    title: 'Sosyal Medya Hesapları',
    route: 'SocialMedia',
    icon: 'Share2Icon',
    resource: 'SOCIAL_MEDIA_LIST',
    action: 'read',
  },
  {
    title: 'Raporlar',
    route: 'ReportDashboard',
    icon: 'ClipboardIcon',
    resource: 'REPORTS',
    action: 'read',
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
]
